import DOMPurify, { type Config } from 'dompurify';

const domPurify = DOMPurify();

// Keep `style` but restrict it to the declarations rich-text content carries:
// text colour, highlight background, and image dimensions from the resize
// handle. Without this, DOMPurify's CSS filter strips them and highlights
// disappear / resized images blow up to natural size. Lives here rather than
// in the rich-text package so every InnerHTMLDiv consumer renders the same,
// regardless of where it was authored.
domPurify.addHook('uponSanitizeAttribute', (_node, data) => {
  if (data.attrName !== 'style') {
    return;
  }

  const safe = data.attrValue
    .split(';')
    .map((decl) => decl.trim())
    .filter((decl) => /^(color|background-color|width|height)\s*:/i.test(decl))
    .join('; ');

  if (safe) {
    data.attrValue = safe;
  } else {
    data.keepAttr = false;
  }
});

domPurify.addHook('afterSanitizeAttributes', (node) => {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const sanitizeHtml = (value: string, overrides?: Config) => {
  const config: Config = {
    ...overrides,
    ADD_ATTR: ['target', 'rel'],
    // <font> is deprecated HTML still embedded in legacy data (Office paste etc.) and
    // hardcodes typography that bypasses the rich-text styling; <style> would leak CSS
    // rules as visible text once attributes are stripped. Strip both but keep inner
    // content for <font>.
    FORBID_TAGS: ['font', 'style'],
    USE_PROFILES: { html: true },
  };
  return domPurify.sanitize(value, config);
};
